/* Copyright 2013 The MathWorks, Inc. */

define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {
        /**
         * It should be mixed in by any component that wants to support a description and descriptionOverride property.
         * @class
         */

        _setDescriptionAttr: function (value) {
            this._set("description", value);

            this._updateDescription();
        },

        _setDescriptionOverrideAttr: function (value) {
            this._set("descriptionOverride", value);

            this._updateDescription();
        },

        _updateDescription: function () {
            var description = "";

            if (this.descriptionOverride) {
                description = this.descriptionOverride;
            } else if (this.description) {
                description = this.description;
            }

            // Some components provide a descriptionNode attach point like list items, while others show the description
            // as their tooltip.
            if (this.descriptionNode) {
                this.descriptionNode.textContent = description;
            }
        }
    });
});

